import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { NodeRow, NodeDetailRow, CreateNodeRequest } from '@/api/types'
import { queryKeys } from '@/lib/queryKeys'
import { REFRESH_INTERVALS } from '@/lib/constants'

export function useNodes() {
  return useQuery({
    queryKey: queryKeys.nodes.list(),
    queryFn: () => api.get<NodeDetailRow[]>('/admin/nodes'),
    refetchInterval: REFRESH_INTERVALS.NODES,
  })
}

export function useNode(id: string) {
  return useQuery({
    queryKey: queryKeys.nodes.detail(id),
    queryFn: () => api.get<NodeDetailRow>(`/admin/nodes/${id}`),
    enabled: !!id,
  })
}

export function useCreateNode() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: CreateNodeRequest) => api.post<NodeRow>('/admin/nodes', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.nodes.all })
      queryClient.invalidateQueries({ queryKey: queryKeys.dashboard })
    },
  })
}

export function useDeleteNode() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => api.delete<string>(`/admin/nodes/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.nodes.all })
      queryClient.invalidateQueries({ queryKey: queryKeys.dashboard })
    },
  })
}
